<script>
const bgc = "#fbcc25";
export default {
  bgc, //公司名背景色
  
};
</script>



// WEBPACK FOOTER //
// src/components/global.vue